module.exports = __webpack_public_path__ + "img/Decline.81a1f8e5.svg";